export const STATUS_META = {
  pending: { key: "assignments.status_pending", cls: "bg-stone-100 text-stone-700 border-stone-200" },
  in_progress: { key: "assignments.status_in_progress", cls: "bg-blue-100 text-blue-700 border-blue-200" },
  completed: { key: "assignments.status_completed", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  overdue: { key: "assignments.status_overdue", cls: "bg-red-100 text-red-700 border-red-200" },
  cancelled: { key: "assignments.status_cancelled", cls: "bg-stone-100 text-stone-400 border-stone-200" },
};

export const PRIORITY_META = {
  low: { key: "assignments.priority_low", cls: "bg-slate-100 text-slate-600", dot: "bg-slate-400" },
  medium: { key: "assignments.priority_medium", cls: "bg-amber-100 text-amber-700", dot: "bg-amber-500" },
  high: { key: "assignments.priority_high", cls: "bg-red-100 text-red-700", dot: "bg-red-500" },
};

export function fmtDate(d, lang) {
  if (!d) return null;
  try {
    const iso = d.length <= 10 ? `${d}T00:00:00` : d;
    return new Date(iso).toLocaleDateString(lang || "en", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return d;
  }
}

export function fmtDuration(sec, t) {
  if (sec == null) return "—";
  const m = Math.round(sec / 60);
  if (m < 60) return `${m} ${t("assignments.minutes_short")}`;
  const h = Math.floor(m / 60);
  const rm = m % 60;
  return `${h}h ${rm}${t("assignments.minutes_short")}`;
}

export function mondayOf(date) {
  const d = new Date(date);
  const day = (d.getDay() + 6) % 7; // 0 = Monday
  d.setDate(d.getDate() - day);
  d.setHours(0, 0, 0, 0);
  return d;
}
